import type { ReactNode } from 'react';

import type { IProductSpecificationReference } from 'src/types/reference/IProductSpecificationReference';
import type { IVendorLeadProduct } from 'src/types/vendors/IVendorLeadProduct';

export enum VendorPageStep {
  Start = 'Start',
  Pictures = 'Pictures',
  Description = 'Description',
  Condition = 'Condition',
  Contact = 'Contact',
  Done = 'Done',
}

export type IVendorStepInfo = {
  step: VendorPageStep;
  description: string;
  icon: ReactNode;
};

export type IVendorsContext = {
  isEditing: boolean;

  isMobileGuideOpened: boolean;

  isLastVendorStep: boolean;

  vendorStep: VendorPageStep;
  vendorStepsInfo: IVendorStepInfo[];
  vendorStepGuideKey: string | null;

  vendorLeadProduct: IVendorLeadProduct | null;
  vendorLeadProductSpecification: IProductSpecificationReference | null;

  onEditing: (newIsEditing: boolean) => void;

  toggleMobileGuideOpened: () => void;

  goNextStep: () => void;
  goBack: () => void;

  setLastVendorStep: (newIsLastVendorStep: boolean) => void;

  setVendorStep: (newVendorStep: VendorPageStep) => void;
  setVendorStepGuideKey: (newVendorStepGuide: string | null) => void;

  updateVendorLeadProduct: (updatedVendorLeadProduct: IVendorLeadProduct) => void;
};
